import { render } from "./organization_profile_setup.html?vue&type=template&id=77ddcf2e&external"
import script from "./organization_profile_setup.js?vue&type=script&lang=js&external"
export * from "./organization_profile_setup.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__